import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import removeKeyFromObject from '../../utils/removeKeyFromObject';
import { DEFAULT_VIEW_KEY } from '../../constants';
import Sort from '../../models/Sort';

function getViews(database) {
  return database.value.views;
}

function getView(database, viewKey) {
  return database.value.views[viewKey];
}

function getCurrentViewKey(database) {
  return DEFAULT_VIEW_KEY;
}

function getCurrentView(database) {
  var key = getCurrentViewKey(database);
  return getView(database, key);
}

function setView(database, key, attrs) {
  return database.applyAction({
    type: 'setView',
    payload: {
      key: key,
      attrs: attrs
    }
  });
}

function setCurrentView(database) {
  var updateFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (x) {
    return x;
  };
  var previousValue = getCurrentView(database);
  return setView(database, previousValue.key, updateFn(previousValue));
}

function getDefaultSort(database) {
  return function (a, b) {
    return a.position - b.position;
  };
}

function getActiveSort(database) {
  var sorts = getCurrentView(database).sorts;

  var _Object$values$sort = Object.values(sorts).sort(function (a, b) {
    return b.createdAt - a.createdAt;
  }),
      _Object$values$sort2 = _slicedToArray(_Object$values$sort, 1),
      activeSort = _Object$values$sort2[0];

  return activeSort;
}

function getActiveSortByColumn(database, columnKey) {
  var activeSort = getActiveSort(database);
  return activeSort && activeSort.columnKey === columnKey ? activeSort : null;
}

function getSortbyColumn(database, columnKey) {
  return getCurrentView(database).sorts[columnKey];
}

function getSortStrategy(database) {
  var sort = getActiveSort(database);
  if (!sort) return getDefaultSort(database);
  var direction = sort.direction,
      columnKey = sort.columnKey;

  var _database$getColumn = database.getColumn(columnKey),
      type = _database$getColumn.type;

  var strategies = database.run('getSortStrategies', type);
  return function (recordA, recordB) {
    return strategies[direction](recordA, recordB, columnKey);
  };
}

function setSort(database, columnKey, direction) {
  database.removeFrozenOrder();
  return setCurrentView(database, function (_ref) {
    var sorts = _ref.sorts,
        view = _objectWithoutProperties(_ref, ["sorts"]);

    return _objectSpread({
      sorts: _defineProperty({}, columnKey, Sort.create({
        columnKey: columnKey,
        direction: direction
      }))
    }, view);
  });
}

function removeSort(database, columnKey) {
  database.removeFrozenOrder();
  return setCurrentView(database, function (_ref2) {
    var sorts = _ref2.sorts,
        view = _objectWithoutProperties(_ref2, ["sorts"]);

    return _objectSpread({
      sorts: removeKeyFromObject(sorts, columnKey)
    }, view);
  });
}

export default {
  commands: {
    setView: setView,
    setCurrentView: setCurrentView,
    setSort: setSort,
    removeSort: removeSort
  },
  queries: {
    getViews: getViews,
    getCurrentView: getCurrentView,
    getView: getView,
    getDefaultSort: getDefaultSort,
    getActiveSort: getActiveSort,
    getActiveSortByColumn: getActiveSortByColumn,
    getSortbyColumn: getSortbyColumn,
    getSortStrategy: getSortStrategy
  }
};